import {Public} from './Public.js';

export class VeejayAdminChannel {
	constructor() {
		let channelUrl = Public.Prefix + `veejay/admin-sse/`;
		console.log(`creating VeejayAdmin to listen ${channelUrl}`);
		this.sse = new EventSource(channelUrl);
		this.sse.addEventListener(`ping`, evt=>{
			console.log(`veejay-admin-sse ping: data = `, evt.data);
		});
		this.sse.addEventListener(`message`, evt=>{
			console.log(`veejay-admin-sse got message, data = `, evt.data);
		});
		this.sse.addEventListener(`admin`, evt=>{
			console.log(`veejay-admin-sse ADMIN message, data = `, evt.data);
		})
		this.sse.onmessage = evt=>{
			console.log(`veejay-sse got unnamed message: `, evt);
		};
	}
}